import type { FC } from 'react'

import type { TimeUnitMode } from '../calendar.types'

import { Box } from '../../box'
import { Button } from '../../button'
import { cs } from '../../utils'
import { months } from '../consts'
import { isDay, isMonth, isYear } from '../utils'

const h = 40
const fontSize = 16

type TimeUnitHeaderProps = {
  onSetTimeUnitMode: (mode: TimeUnitMode) => void
  timeUnitMode: TimeUnitMode
  viewMonth: Date
}

/**
 * Displays the header title with the month and year being viewed
 */
export const TimeUnitHeader: FC<TimeUnitHeaderProps> = ({ onSetTimeUnitMode, timeUnitMode, viewMonth }) => {
  return (
    <Box center className={cs('vui-time-unit-header')} cursor="pointer" flex="1" justifyItems="flex-start" gap="2px">
      {isDay(timeUnitMode) && (
        <>
          <Button
            fontSize={fontSize}
            h={h}
            onClick={() => onSetTimeUnitMode('month')}
            variant="tertiary"
            px="6px"
            minW="auto"
          >
            {months[viewMonth.getUTCMonth()]}
          </Button>
          <Button
            fontSize={fontSize}
            h={h}
            onClick={() => onSetTimeUnitMode('year')}
            variant="tertiary"
            px="6px"
            minW="auto"
          >
            {viewMonth.getUTCFullYear()}
          </Button>
        </>
      )}
      {isMonth(timeUnitMode) && (
        <Button
          fontSize={fontSize}
          h={h}
          onClick={() => onSetTimeUnitMode('year')}
          variant="tertiary"
          px="6px"
          minW="auto"
        >
          {viewMonth.getUTCFullYear()}
        </Button>
      )}
      {isYear(timeUnitMode) && (
        <Button
          fontSize={fontSize}
          h={h}
          onClick={() => onSetTimeUnitMode('day')}
          variant="tertiary"
          px="6px"
          minW="auto"
        >
          Year
        </Button>
      )}
    </Box>
  )
}
